import { useContext } from 'react';
import { ErrorBoundaryContext } from 'react-error-boundary';
import styled from 'styled-components';

import { Space, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import Heading from '@/components/Typography/Heading';
import Typo from '@/components/Typography/Typo';
import { CLIENT_SIDE_ERROR_CODE } from '@/error-handler/ClientError';
import useColor from '@/hooks/domain/useColor';
import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';

import DynamicImportError from '../Setting/Integrations/integrationRedirection/DynamicImportError';
import ServerErrorPage from './500';

function ErrorPage({ statusCode }: { statusCode?: number }) {
  const color = useColor();
  const { navigate } = useWorkspaceRouter();
  const context = useContext(ErrorBoundaryContext);
  if (context?.error.message === CLIENT_SIDE_ERROR_CODE.DYNAMIC_IMPORT_ERROR)
    return <DynamicImportError />;
  if (statusCode) return <ServerErrorPage />;
  return (
    <Style a="center" j="center" d="column">
      <img src="/assets/logo-syncly.svg" width={54} height={54} alt="syncly" />
      <Space h="32px" />
      <Heading type="hero">500</Heading>
      <Space h="16px" />
      <Heading type="h2" color={color.gray700}>
        Something went wrong
      </Heading>
      <Space h="8px" />
      <Typo type="label1" color={color.gray600}>
        Please try again later or feel free to contact us if the problem
        persists.
      </Typo>
      <Space h="24px" />
      <Button
        variant="primary"
        sizeType="m"
        onClick={() => {
          navigate('/');
        }}
      >
        Go back to the workspace
      </Button>
    </Style>
  );
}

const Style = styled(VFlex)`
  min-height: 100vh;
`;

export default ErrorPage;
